export default __webpack_public_path__ + "static/media/dot_non-ce.fca64cb8.svg";